export type ClientDocumentCategoryApi = 'productBrochure' | 'contract' | 'marketingMedia';
export type ClientDocumentCategory = ClientDocumentCategoryApi | 'other';

export interface ClientDocumentDto {
  marketingFileID: number;
  name: string;
  friendlyName?: string | null;
  viewUrl?: string | null;
  downloadUrl?: string;
  fileType?: string;
  fileSize: number;
  description?: string | null;
  category?: string | number;
  createdAt?: string;
  mcode?: string;
}

export const CLIENT_DOCUMENT_CATEGORY_OPTIONS: ReadonlyArray<{
  value: ClientDocumentCategoryApi;
  label: string;
}> = [
  { value: 'productBrochure', label: 'Product Brochure' },
  { value: 'contract', label: 'Contract' },
  { value: 'marketingMedia', label: 'Marketing Media' },
];

export function normalizeCategory(raw: string | number | undefined | null): ClientDocumentCategory {
  if (raw == null) return 'other';
  const c = typeof raw === 'string' ? raw.toLowerCase() : raw;
  if (c === 1 || c === '1' || c === 'productbrochure') return 'productBrochure';
  if (c === 2 || c === '2' || c === 'contract') return 'contract';
  if (c === 3 || c === '3' || c === 'marketingmedia') return 'marketingMedia';
  return 'other';
}

export function displayClientDocumentCategory(
  category: ClientDocumentDto['category']
): string {
  const c = category;
  if (
    c === 1 || c === '1' || (typeof c === 'string' && c.toLowerCase() === 'productbrochure')
  ) {
    return 'Product Brochure';
  }
  if (
    c === 2 || c === '2' || (typeof c === 'string' && c.toLowerCase() === 'contract')
  ) {
    return 'Contract';
  }
  if (
    c === 3 || c === '3' || (typeof c === 'string' && c.toLowerCase() === 'marketingmedia')
  ) {
    return 'Marketing Media';
  }
  return typeof c === 'string' ? c : '–';
}

export function displayDocumentName(doc: ClientDocumentDto): string {
  return doc.friendlyName?.trim() || doc.name;
}

export interface ClientDocumentViewUrlResponse {
  viewUrl: string;
}

export interface ClientDocumentDownloadUrlResponse {
  downloadUrl: string;
}

export interface ClientDocumentsPagedResponse {
  items: ClientDocumentDto[];
  totalCount: number;
  currentPage: number;
  pageSize: number;
  totalPages: number;
  hasPrevious: boolean;
  hasNext: boolean;
}

export interface ClientDocumentsQueryParams {
  page?: number;
  pageSize?: number;
  orderByField?: string;
  orderBy?: string;
  documentCategory?: string | number;
  fileName?: string;
}
